import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'

export type WorkerRequirement = {
  id: number
  displayName: string
  verificationType: string
}

export type ListWorkerRequirementsParams = {
  displayName?: string
}

export type ListWorkerRequirementsResponse = {
  items: WorkerRequirement[]
}

export async function listWorkerRequirements(
  params: ListWorkerRequirementsParams = {}
): Promise<ListWorkerRequirementsResponse> {
  const result = await api.get<ListWorkerRequirementsResponse>(
    '/admin/credentials/worker_requirements',
    {
      params,
      paramsSerializer: queryParamSerializer,
    }
  )
  return result.data
}
